// メール形式チェック
function checkMail(val) {
    var re = /^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-\.]*$/;
    return re.test(val);
}

// 半角英数字チェック
function checkStringType(val) {
    var re = /^[A-Za-z0-9]*$/;
    return re.test(val);
}

// アルファベットを含む半角英数チェック
function checkComplexity(val) {
    var re = /^(?=.*?[a-z])(?=.*?\d)[a-z\d]+$/i;
    return re.test(val);
}

// 半角数字だけかチェック
function checkIntType(val) {
    var re = /^([1-9]\d*|0)$/;
    return re.test(val);
}

// 全角半角カナチェック
function checkZenHanKana(val) {
    var re = /^[ァ-ヶｦ-ﾟー\-]*$/;
    return re.test(val);
}

function checkPoint(val) {
    var re = /^[1-9]/;
    return re.test(val);
}

function checkTel (val) {
    var re = /^\d*$/;
    return re.test(val);
}

// 電話番号チェック
function checktelephone (val) {
    var valreplace = val.replace(/[━.*‐.*―.*－.*\-.*ー.*\-]/gi,'');
    var re = /^(0[5-9]0[0-9]{8}|0[1-9][1-9][0-9]{7})$/;
    return re.test(valreplace);
}

// 携帯番号チェック
function checkmobilenumber (val) {
    var re = /^0[7-9]0?[1-9]\d{3}?\d{4}$/;
    return re.test(val);
}

function checkmobilenumberNoHyphen(val) {
    var re = /^0\d{10}$/;
    return re.test(val);
}

// 文字数チェック(最大)
function checkStringLengthMax(val, maxCount) {
    if (val.length > maxCount) {
        return false;
    }
    return true
}

// 文字数チェック(最小)
function checkStringLengthMin(val, maxCount) {
    if (val.length < maxCount) {
        return false;
    }
    return true
}

// 数字のみチェック
function checkNumber (val) {
    var re = /^[0-9]*$/;
    return re.test(val);
}

export default { checkMail, checkStringType, checkComplexity, checkStringLengthMax, checkStringLengthMin, checkNumber, checkIntType, checkPoint, checkTel, checktelephone , checkmobilenumber , checkmobilenumberNoHyphen, checkZenHanKana}
